/**
 * Branded ID types. Prevents accidentally passing a CategoryId where a ProductId is
 * expected — both are strings at runtime but distinct at compile-time.
 */

type Brand<T, B> = T & { readonly __brand: B };

export type ProductId = Brand<string, 'ProductId'>;
export type CategoryId = Brand<string, 'CategoryId'>;
export type UserId = Brand<string, 'UserId'>;
export type CartId = Brand<string, 'CartId'>;
export type OrderId = Brand<string, 'OrderId'>;
export type PromotionId = Brand<string, 'PromotionId'>;
export type WishlistId = Brand<string, 'WishlistId'>;

function makeId<B>(value: unknown, label: string): Brand<string, B> {
  const str = typeof value === 'number' ? String(value) : value;
  if (typeof str !== 'string' || str.length === 0) {
    throw new Error(`Invalid ${label}: ${String(value)}`);
  }
  return str as Brand<string, B>;
}

export const productId = (v: unknown): ProductId => makeId<'ProductId'>(v, 'ProductId');
export const categoryId = (v: unknown): CategoryId => makeId<'CategoryId'>(v, 'CategoryId');
export const userId = (v: unknown): UserId => makeId<'UserId'>(v, 'UserId');
export const cartId = (v: unknown): CartId => makeId<'CartId'>(v, 'CartId');
export const orderId = (v: unknown): OrderId => makeId<'OrderId'>(v, 'OrderId');
export const promotionId = (v: unknown): PromotionId => makeId<'PromotionId'>(v, 'PromotionId');
export const wishlistId = (v: unknown): WishlistId => makeId<'WishlistId'>(v, 'WishlistId');
